import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { SharedService } from 'src/app/services/shared.service';
import { HeaderPagesService } from '../header-pages.service';
import { AddEditIssueComponent } from './add-edit-issue/add-edit-issue.component';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {
  dataList: any = [];
  pageSettings: PageSettingsModel;

  constructor(
    private dialogRef: MatDialogRef<SupportComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private headerPagesService: HeaderPagesService,
    public sharedService: SharedService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.pageSettings = this.sharedService.resetPageSettings();
    this.getAllIssues();
  }

  getAllIssues() {
    this.headerPagesService.getAllIssues(this.sharedService.currentUser.Labs[0].LabCode).subscribe(res => {
      if (res) {
        this.dataList = res;
      }
    });
  }

  addEditIssue(item?) {
    const dialogRef = this.dialog.open(AddEditIssueComponent, {
      width: '40%',
      disableClose: true,
      data: (item) ? { issueId: item.id } : null
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAllIssues();
      }
    });
  }

  cancelClick(): void {
    this.dialogRef.close();
  }

}
